import { render, staticRenderFns } from "./DirectoryView.vue?vue&type=template&id=c38de06c&scoped=true"
import script from "./DirectoryView.vue?vue&type=script&lang=js"
export * from "./DirectoryView.vue?vue&type=script&lang=js"
import style0 from "./DirectoryView.vue?vue&type=style&index=0&id=c38de06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38de06c",
  null
  
)

export default component.exports